import { useContext } from 'react';
import { PromoCodesContext } from './promoCodesContext';

export const usePromoCodes = () => {
    const context = useContext(PromoCodesContext);

    if (!context) {
        return { promoCodes: [], excludeList: [] }
    }

    return context
};

export const usePromoCodesByCatalogOsr = (catalogOsr) => {
    const context = useContext(PromoCodesContext)

    if (!context) {
        return { promoCodes: [], excludeList: [] }
    }

    const catalogPromoCodes = context?.promoCodes?.filter(promoCode => promoCode.catalogOSR === catalogOsr)

    return { promoCodes: catalogPromoCodes, excludeList: context.excludeList }
}